import React from "react";
import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";
import DialogStatusPopup from "../common/DialogStatusPopup";
import { useMediaQuery, useTheme } from "@mui/system";
import Logo from "../../assets/svgIcons/logo2.svg";
import SingleDashboardIcon from "../../assets/icons/auth/single_dashboard.svg";
import ApplicationTrackingIcon from "../../assets/icons/auth/application_tracking.svg";
import FundReleaseIcon from "../../assets/icons/auth/fund_release.svg";
import LoanDocumentIcon from "../../assets/icons/auth/loan_document.svg";
import PartPaymentIcon from "../../assets/icons/auth/part_payment.svg";
import ViewLoanDetailsIcon from "../../assets/icons/auth/view_loan_details.svg";
import AvanseAuthLogo from "../../assets/icons/auth/avanse_auth.png";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Carousel from "react-multi-carousel";
// @ts-ignore
import "react-multi-carousel/lib/styles.css";
import circleUnderline from "../../assets/icons/auth/ring.png";
import { useTriggerData } from "../../hooks";

const data = [
  {
    title: "Single \n Dashboard",
    icon: SingleDashboardIcon,
  },
  {
    title: "Application \n Tracking",
    icon: ApplicationTrackingIcon,
  },
  {
    title: "Fund \n Release",
    icon: FundReleaseIcon,
  },
  {
    title: "Loan \n Document",
    icon: LoanDocumentIcon,
  },
  {
    title: "Part \n Payment",
    icon: PartPaymentIcon,
  },
  {
    title: "View loan \n Details",
    icon: ViewLoanDetailsIcon,
  },
];

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 4,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 3,
    slidesToSlide: 1,
  },
};

const AuthLayout = () => {
  let spacing = 4;
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));

  const { isTriggerDataEmpty }: any = useTriggerData();

  const navigate = useNavigate();

  if (isXsOrSm) {
    spacing = 0;
  }

  return (
    <Grid container component="main" className="container-auth">
      <Grid item xs={12} sm={12} md={7} sx={{ background: "#EBF9F9" }}>
        <div style={{ padding: isXsOrSm ? "0px 0px 42px 0px" : "" }}>
          <div
            style={
              isXsOrSm
                ? {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }
                : { padding: "0px 30px" }
            }
          >
            <img
              src={AvanseAuthLogo}
              alt="Logo"
              style={{
                maxWidth: isXsOrSm ? "100%" : "200px",
                height: isXsOrSm ? "auto" : "auto",
                display: "block",
                marginTop: isXsOrSm ? "10px" : "24px",
                marginBottom: isXsOrSm ? "20px" : "0px",
                mixBlendMode: "multiply",
              }}
            />
          </div>

          {!isXsOrSm && (
            <Box sx={{ padding: "0px 82px" }}>
              <Box
                className="background-section"
                style={{ marginTop: isXsOrSm ? "" : "48px" }}
              ></Box>
            </Box>
          )}

          <Box
            sx={{
              marginTop: "25px",
              padding: isXsOrSm ? "0px 24px" : "0px 82px",
            }}
          >
            <Box>
              {/* <div className="testH">
                Get ready to{" "}
                <span className="ring-img" style={{ color: "#00B3B5" }}>
                  revolutionize
                </span>{" "}
                your loan management experience!
              </div> */}
              <Typography
                component="h1"
                className="testH"
              >
                Get ready to{" "}
                <Box
                  component="span"
                  sx={{
                    position: "relative",
                    display: "inline-block",
                    color: "#00B3B5",
                  }}
                >
                  revolutionize
                  {/* hand-drawn circle accent */}
                  <Box
                    component="img"
                    src={circleUnderline}
                    alt=""
                    sx={{
                      position: "absolute",
                      left: "50%",
                      top: "48%",
                      width: "110%",
                      height: "170%",
                      transform: "translate(-50%, -50%)",
                      objectFit: "contain",
                      pointerEvents: "none",
                      userSelect: "none",
                    }}
                  />
                </Box>{" "}
                your loan management experience!
              </Typography>
              <p className="login-sub-h">
                <span>
                  Access all your education loan details in a unified platform
                </span>
              </p>
              {isTriggerDataEmpty && (
                <Box
                  sx={{ 
                    marginTop: isXsOrSm ? "20px" : "38px", 
                    width: "100%" , 
                    display: "flex", 
                    alignItems: "center", 
                    gap: "12px", 
                  }}
                >
                  <Button
                    endIcon={
                      <ArrowForwardIosIcon
                        sx={
                          isXsOrSm
                            ? { width: 14, height: 14 }
                            : { width: 15, height: 15 }
                        }
                      />
                    }
                    sx={{
                      borderRadius: isXsOrSm ? "8px" : "20px",
                      height: "auto",
                      width: isXsOrSm ? "140px" : "160px",
                      padding: isXsOrSm ? "8px 0px" : "12px 0",
                      background: "#ffcc02",
                      color: "#000000",
                      fontWeight: "600",
                      textTransform: "capitalize",
                      fontSize: isXsOrSm ? "14px" : "16px",
                      "&:hover": {
                        background: "#e6b800",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                      },
                    }}
                    onClick={() => navigate("/apply-now?leadoriginsource=customerportalredirection&source=customerportalredirection&utm_source=customerportalredirection&name=customerdiyjourney&code=MUM%2F101918")}
                  >
                    Apply Now
                  </Button>

                  <Button
                    variant="outlined"
                    sx={{
                      // borderWidth: "1px",
                      borderColor: "rgba(0, 179, 181, 1)",
                      borderRadius: isXsOrSm ? "8px" : "20px",
                      height: "auto",
                      width: isXsOrSm ? "140px" : "160px",
                      padding: isXsOrSm ? "8px 0px" : "12px 0",
                      background: "rgba(238, 249, 249, 0.2)",
                      color: "#000000",
                      fontWeight: "600",
                      textTransform: "capitalize",
                      fontSize: isXsOrSm ? "14px" : "16px",
                      "&:hover": {
                        background: "rgba(42, 203, 203, 0.1)",
                        boxShadow: "0 4px 12px rgba(0, 179, 181, 0.2)",
                        borderColor: "rgba(0, 179, 181, 1)"
                      },
                    }}
                    onClick={() => navigate("/help-center")}
                  >
                    View Tickets
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
        </div>
      </Grid>

      <Grid item xs={12} sm={12} md={5} component={Paper} elevation={0}>
        <Box
          className="main-section"
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: isXsOrSm ? "24px" : "86px",
          }}
        >
          <Outlet />
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box
              sx={{
                width: "100%",
              }}
            >
              <Carousel
                swipeable={true}
                draggable={true}
                showDots={false}
                key={window.location.pathname || "loan-products-carousel"}
                infinite={true}
                arrows={false}
                ssr={true}
                autoPlay={true}
                responsive={responsive}
                autoPlaySpeed={2000}
                keyBoardControl={true}
                customTransition="transform 300ms ease-in-out"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                deviceType={isXsOrSm ? "mobile" : "desktop"}
                dotListClass="custom-dot-list-style"
                partialVisible={true}
                centerMode={false}
                minimumTouchDrag={50}
                itemClass="carousel-item-padding-auth"
                containerClass="carousel-container"
              >
                {data.map((item: any) => (
                  <Box key={item.title} textAlign="center">
                    <img src={item.icon} alt={item.title} />

                    {item.title.split("\n").map((line: string, i: number) => (
                      <Typography
                        key={i}
                        sx={{
                          fontSize: "15px",
                          fontFamily: "jost",
                        }}
                      >
                        {line}
                        <br />
                      </Typography>
                    ))}
                  </Box>
                ))}
              </Carousel>
            </Box>
          </Box>
        </Box>
      </Grid>

      <DialogStatusPopup />
    </Grid>
  );
};

export default AuthLayout;
